import { stripHtml } from 'core/utils/utils';
import React from 'react';
import ProgramImage from '../../general/ProgramImage/ProgramImage';
import HeaderCustom from '../HeaderCustom';

type HeaderCourseSimpleProps = {
  courseName: string;
  classroomName: string;
  coursePicture: string;
  onClose: () => void;
  themeColor?: string;
  gradient?: string;
  picture?: string;
  themeImage?: string;
};

function HeaderCourseSimple({ courseName, classroomName, coursePicture, themeColor, gradient, themeImage, onClose }: HeaderCourseSimpleProps) {
  function headerLeft() {
    return (
      <div className="header-lesson__left">
        <div className="header-lesson__left-info">
          {coursePicture && (
            <ProgramImage
              configProgramPicture={coursePicture}
              iconType={'program'}
              gradient={themeColor ? themeColor : gradient}
              course_picture={coursePicture}
              themeImage={themeImage}
            />
          )}
          <div className="header-lesson__left-info-texts">
            <span className="header-lesson__left-info-title">{stripHtml(courseName)}</span>
            <span className="header-lesson__left-info-subtitle">{classroomName}</span>
          </div>
        </div>
      </div>
    );
  }
  return <HeaderCustom className="header-lesson" left={headerLeft()} center="" right="" onClose={onClose} />;
}

export default HeaderCourseSimple;
